<template>
  <div>
    <div v-if="loading" class="title-section-content">
      <h3>Carregando...</h3>
    </div>

    <div v-else>
      <table class="footable table table-bordered table-striped table-highlight">
        <thead>
          <tr>
            <th>ID do Módulo</th>
            <th>Módulo</th>
            <th>ID do Produto</th>
            <th>Produto</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="product in products" :key="product.id">
            <td>{{product.moduleId}}</td>
            <td>{{product.modulename}}</td>
            <td>{{product.id}}</td>
            <td>{{product.name}}</td>
          </tr>
        </tbody>
      </table>

    
        
          
    </div>

    
  </div>
</template>

<style scoped>
.custom-link {
  padding: 0px;
}
.custom-grid {
  grid-template-columns: 1fr 1fr 1fr 1fr 0.75fr !important;
}
.custom-grid-modal {
  grid-template-columns: 1fr 1fr 0.75fr !important;
}
* {
  padding: 0;
  margin: 0;
}

.float {
  position: fixed;
  height: 60px;
  bottom: 40px;
  right: 40px;
  color: #fff;
  text-align: center;
  box-shadow: 2px 2px 3px #999;
}

.my-float {
  margin-top: 22px;
}
</style>


<script>
import axios from "axios";

axios.defaults.withCredentials = true;

export default {
  props: ["course", "modules", "teachers"],
  data() {
    return {
      loading: false,
      products: []
    };
  },
  computed: {},
  components: {},
  methods: {

    getProductModules(modules) {

      console.log("getProductModules");
      
      const path = this.$global.endpoint + "/course/productModule";
      
      axios
        .post(path, { modules: modules })
        .then(res => {
          this.products = res.data;
          console.log("getProductModules", this.products);
          this.$emit("changed");
         
        })
        .catch(error => {
          console.error(error);
        });
    }
  },
  mounted() {
    this.getProductModules(this.modules);
  }
};
</script>
